import { jsx } from "react/jsx-runtime";
import React__default from "react";
import { formatRawHours } from "../helpers.js";
import { ChainableNumberInput } from "./chainable-number-input.js";
const HoursInput = React__default.forwardRef(
  ({ value, onChange, onBlur, period, use24Hours, ...rest }, ref) => {
    const handleBlur = (ev) => {
      if (value) {
        const validHours = formatRawHours(value, use24Hours);
        const intHours = parseInt(value, 10);
        if (!use24Hours && intHours > 12) {
          onChange(validHours, intHours >= 24 ? "AM" : "PM");
        } else {
          onChange(validHours);
        }
      }
      onBlur?.(ev);
    };
    const onCycle = (newValue) => {
      onChange(newValue, period === "AM" ? "PM" : "AM");
    };
    return /* @__PURE__ */ jsx(
      ChainableNumberInput,
      {
        ref,
        min: use24Hours ? 0 : 1,
        max: use24Hours ? 23 : 12,
        value,
        onChange,
        onCycle,
        onBlur: handleBlur,
        "data-hook": "hours",
        ...rest
      }
    );
  }
);
HoursInput.displayName = "HoursInput";
export {
  HoursInput
};
//# sourceMappingURL=hours-input.js.map
